export const DefaultEvent = require("../../../assets/images/default-event.png");
export const DefaultProfileImage = require("../../../assets/images/default-profile.jpeg");
export const AppStoreDownload = require("../../../assets/images/app-store-download.png");
export const BlueCheckmark = require("../../../assets/images/blue-checkmark-original.png");
export const Gradient1 = require("../../../assets/images/gradient-1.png");
export const Gradient2 = require("../../../assets/images/gradient-2.png");
export const Gradient3 = require("../../../assets/images/gradient-3.png");
export const Gradient4 = require("../../../assets/images/gradient-4.png");
export const Gradient5 = require("../../../assets/images/gradient-5.png");
